// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import carpark1 from '@/assets/img/car-park-1.png';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import TaifContract from '@/assets/img/TaifContract.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import { API_CALL_TIME } from '@/constants/constant';

// // ─── Fallback Data (Gazzaz specific) ──────────────────────────────────────────
// const FALLBACK_PARKING = {
//   table_key: 'gazzaz_offstreet_parking_profile',
//   title: 'Gazzaz Off Street Parking - Profile',
//   data: {
//     car_park_bays:     { label: 'Total Off-Street Parking Bays', value: '287' },
//     contract_term:     { label: 'Contract Term', value: '25 years' },
//     contract_period:   { start_date: '29/03/2017', end_date: '29/06/2041' },
//     operational_hours: { label: 'Operational Hours', value: '24 Hours' },
//     vat_note:          { label: 'Rate per Hour', value: 'SAR 06.00 including 15% VAT' },
//   },
// };

// const FALLBACK_MEMBERSHIP = {
//   table_key: 'gazzaz_membership_tariff',
//   title: 'Membership Tariff',
//   data: {
//     columns: ['MEMBERSHIP TARIFF', 'Price'],
//     rows: [
//       ['Causal Members',       'SAR 350 + VAT'],
//       ['Shop Owners/Tenants',  'SAR 175 + VAT'],
//     ],
//   },
// };

// const FALLBACK_ASSETS = {
//   table_key: 'gazzaz_assets_deployed',
//   title: 'Gazzaz Off-Street',
//   data: {
//     groups: [
//       { group_name: 'Ticket Dispenser',    group_total_qty: '1', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//       { group_name: 'Ticket Verifier',     group_total_qty: '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//       { group_name: "APM's",               group_total_qty: '1', items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
//       { group_name: 'PIN Pad',             group_total_qty: '1', items: [{ item_name: 'IUP250', qty: '1' }] },
//       { group_name: 'Card Reader',         group_total_qty: '1', items: [{ item_name: 'IUR250', qty: '1' }] },
//       { group_name: 'B-Contactless',       group_total_qty: '1', items: [{ item_name: 'IUC150', qty: '1' }] },
//       { group_name: 'RFID Reader',         group_total_qty: '2', items: [] },
//       { group_name: 'IP Barrier',          group_total_qty: '2', items: [] },
//       { group_name: 'ANPR Camera',         group_total_qty: '2', items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
//       { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//       { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//       { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//       { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
//       { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//       { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//       { group_name: 'Printer',             group_total_qty: '2', items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//       { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
//       { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
//       { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
//     ],
//   },
// };

// // ─── Helpers (same as before) ─────────────────────────────────────────────────
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// const Gazzaz_11 = ({ year = '', monthNumber = '', contract = '' }) => {
//   const saveTimeoutRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [parkingData, setParkingData] = useState(null);
//   const [membershipData, setMembershipData] = useState(null);
//   const [assetsData, setAssetsData] = useState(null);
  
//   const { enqueue } = useApiQueue();
  
//   // Refs for parking inputs
//   const totalBaysRef = useRef(null);
//   const contractTermRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
//   const operationalHoursRef = useRef(null);
//   const vatNoteRef = useRef(null);
  
//   // Refs for membership table
//   const membershipRefs = useRef([]);
  
//   // Refs for assets
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);

//   // State refs for data
//   const parkingDataRef = useRef(null);
//   const membershipDataRef = useRef(null);
//   const assetsDataRef = useRef(null);

//   // ── Fetch ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await enqueue(() =>
//           apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//         if (!response?.success) return;
//         const data = response?.data || [];
//         const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        
//         const parking = find('gazzaz_offstreet_parking_profile', FALLBACK_PARKING);
//         const membership = find('gazzaz_membership_tariff', FALLBACK_MEMBERSHIP);
//         const assets = find('gazzaz_assets_deployed', FALLBACK_ASSETS);
        
//         setParkingData(parking);
//         setMembershipData(membership);
//         setAssetsData(assets);
        
//         parkingDataRef.current = parking;
//         membershipDataRef.current = membership;
//         assetsDataRef.current = assets;
//       } catch (err) {
//         console.error('Fetch error:', err);
//       }
//     };
//     fetchData();
//   }, [year, monthNumber, contract]);

//   // ── Auto-save ─────────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
//     saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = assetsDataRef.current?.data?.groups || [];
//     const groups = [];
//     let currentGroup = null;
//     let flatIdx = 0;

//     currentAssets.forEach((group) => {
//       currentGroup = {
//         group_name: group.group_name,
//         group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
//         items: []
//       };
//       flatIdx++;
      
//       (group.items || []).forEach((item) => {
//         currentGroup.items.push({
//           item_name: item.item_name,
//           qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
//         });
//         flatIdx++;
//       });
      
//       groups.push(currentGroup);
//     });
    
//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
      
//       // Get current values from refs
//       const currentTotalBays = totalBaysRef.current?.value || parkingDataRef.current?.data?.car_park_bays?.value || '';
//       const currentContractTerm = contractTermRef.current?.value || parkingDataRef.current?.data?.contract_term?.value || '';
//       const currentStartDate = contractStartDateRef.current?.value || parkingDataRef.current?.data?.contract_period?.start_date || '';
//       const currentEndDate = contractEndDateRef.current?.value || parkingDataRef.current?.data?.contract_period?.end_date || '';
//       const currentOperationalHours = operationalHoursRef.current?.value || parkingDataRef.current?.data?.operational_hours?.value || '';
//       const currentVatNote = vatNoteRef.current?.value || parkingDataRef.current?.data?.vat_note?.value || '';
      
//       // Build membership rows from refs
//       const currentMembershipRows = (membershipDataRef.current?.data?.rows || []).map((row, rowIdx) => 
//         row.map((_, colIdx) => membershipRefs.current[rowIdx]?.[colIdx]?.value || row[colIdx] || '')
//       );
      
//       const response = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1,
//         tables: [
//           { 
//             table_key: parkingDataRef.current?.table_key || 'gazzaz_offstreet_parking_profile', 
//             title: parkingDataRef.current?.title || 'Gazzaz Off Street Parking - Profile', 
//             data: {
//               car_park_bays: { label: 'Total Off-Street Parking Bays', value: currentTotalBays },
//               contract_term: { label: 'Contract Term', value: currentContractTerm },
//               contract_period: { start_date: currentStartDate, end_date: currentEndDate },
//               operational_hours: { label: 'Operational Hours', value: currentOperationalHours },
//               vat_note: { label: 'Rate per Hour', value: currentVatNote }
//             }
//           },
//           { 
//             table_key: membershipDataRef.current?.table_key || 'gazzaz_membership_tariff', 
//             title: membershipDataRef.current?.title || 'Membership Tariff', 
//             data: {
//               columns: membershipDataRef.current?.data?.columns || ['MEMBERSHIP TARIFF', 'Price'],
//               rows: currentMembershipRows
//             }
//           },
//           { 
//             table_key: assetsDataRef.current?.table_key || 'gazzaz_assets_deployed', 
//             title: assetsDataRef.current?.title || 'Gazzaz Off-Street', 
//             data: { groups: transformAssetsToApiFormat() }
//           },
//         ],
//       });
      
//       if (!response?.success) throw new Error(response?.message || 'Save failed');
//       // toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   if (!parkingData || !membershipData || !assetsData) {
//     return <LoadingComponent/>;
//   }

//   const pkd = parkingData.data;
//   const memColumns = membershipData.data.columns || [];
//   const memRows = membershipData.data.rows || [];
//   const flatAssets = groupsToFlat(assetsData.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{parkingData.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ── Left ── */}
//         <div className="flex-1 !border-black pr-4">
//           <div className="text-[13px] font-semibold mb-4">Activities:</div>

//           {/* Car Park image box */}
//           <div className="rounded mb-4 w-[140px] flex flex-col items-center">
//             <img src={carpark1} alt="Car Park" className="w-48 h-48 object-contain" />
//           </div>

//           {/* Total Bays */}
//           <div className="flex items-center gap-2 mb-1 ml-4">
//             <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               {pkd.car_park_bays?.label}{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.car_park_bays?.value || ''}
//                   ref={totalBaysRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-16" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Contract Term */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px] flex items-center flex-wrap gap-1">
//               Contract term{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.contract_term?.value || ''}
//                   ref={contractTermRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
//                 />
//               </strong>
//               ; start date{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.contract_period?.start_date || ''}
//                   ref={contractStartDateRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-18" 
//                 />
//               </strong>
//               {' to '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.contract_period?.end_date || ''}
//                   ref={contractEndDateRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Operational Hours */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Operational Hours –{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.operational_hours?.value || ''}
//                   ref={operationalHoursRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-48" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Rate per Hour */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Rate per Hour{' '}
//               <strong>
//                 <input 
//                   type="text" 
//                   defaultValue={pkd.vat_note?.value || ''}
//                   ref={vatNoteRef}
//                   onChange={autoSave}
//                   className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-48" 
//                 />
//               </strong>
//             </span>
//           </div>

//           {/* Assets Deployed */}
//           <div className="flex items-center gap-2 ml-4 mb-6">
//             <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//             <span className="text-[12px]">Assets Deployed</span>
//           </div>

//           {/* Membership Rates Table */}
//           <div className="ml-4">
//             <table className="!border-collapse text-[11px]">
//               <thead>
//                 <tr>
//                   <th colSpan={memColumns.length} className="!border !border-black px-3 py-1.5 font-bold text-center bg-white">
//                     {membershipData.title}
//                   </th>
//                 </tr>
//                 <tr>
//                   {memColumns.map((col, i) => (
//                     <th key={i} className="!border !border-black px-3 py-1 font-semibold text-left bg-white"
//                       style={{ minWidth: i === 0 ? '140px' : '110px' }}>
//                       {col}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {memRows.map((row, rIdx) => (
//                   <tr key={rIdx}>
//                     {row.map((cell, cIdx) => {
//                       if (!membershipRefs.current[rIdx]) membershipRefs.current[rIdx] = [];
//                       return (
//                         <td key={cIdx} className="!border !border-black px-3 py-1">
//                           <input 
//                             type="text" 
//                             defaultValue={cell}
//                             ref={(el) => (membershipRefs.current[rIdx][cIdx] = el)}
//                             onChange={autoSave}
//                             className="outline-none bg-transparent !border-0 w-full text-[11px]" 
//                           />
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ── Right — Assets ── */}
//         <AssetsPanel
//           assetsTable={assetsData}
//           flatAssets={flatAssets}
//           subCountRefs={assetSubCountRefs}
//           totalCountRefs={assetTotalCountRefs}
//           onSubCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//           onTotalCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default Gazzaz_11;
















import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import carpark1 from '@/assets/img/car-park-1.png';
import { useApiQueue } from '@/hooks/useApiQueue';
import TaifContract from '@/assets/img/TaifContract.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import { API_CALL_TIME } from '@/constants/constant';

// ─── Fallback Data (Gazzaz specific) ──────────────────────────────────────────
const FALLBACK_PARKING = {
  table_key: 'gazzaz_offstreet_parking_profile',
  title: 'Gazzaz Off Street Parking - Profile',
  data: {
    car_park_bays:     { label: 'Total Off-Street Parking Bays', value: '287' },
    contract_term:     { label: 'Contract Term', value: '25 years' },
    contract_period:   { start_date: '29/03/2017', end_date: '29/06/2041' },
    operational_hours: { label: 'Operational Hours', value: '24 Hours' },
    vat_note:          { label: 'Rate per Hour', value: 'SAR 06.00 including 15% VAT' },
  },
};

const FALLBACK_MEMBERSHIP = {
  table_key: 'gazzaz_membership_tariff',
  title: 'Membership Tariff',
  data: {
    columns: ['MEMBERSHIP TARIFF', 'Price'],
    rows: [
      ['Causal Members',       'SAR 350 + VAT'],
      ['Shop Owners/Tenants',  'SAR 175 + VAT'],
    ],
  },
};

const FALLBACK_ASSETS = {
  table_key: 'gazzaz_assets_deployed',
  title: 'Gazzaz Off-Street',
  data: {
    groups: [
      { group_name: 'Ticket Dispenser',    group_total_qty: '1', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
      { group_name: 'Ticket Verifier',     group_total_qty: '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
      { group_name: "APM's",               group_total_qty: '1', items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
      { group_name: 'PIN Pad',             group_total_qty: '1', items: [{ item_name: 'IUP250', qty: '1' }] },
      { group_name: 'Card Reader',         group_total_qty: '1', items: [{ item_name: 'IUR250', qty: '1' }] },
      { group_name: 'B-Contactless',       group_total_qty: '1', items: [{ item_name: 'IUC150', qty: '1' }] },
      { group_name: 'RFID Reader',         group_total_qty: '2', items: [] },
      { group_name: 'IP Barrier',          group_total_qty: '2', items: [] },
      { group_name: 'ANPR Camera',         group_total_qty: '2', items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
      { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
      { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
      { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
      { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
      { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
      { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
      { group_name: 'Printer',             group_total_qty: '2', items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
      { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
      { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
      { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
    ],
  },
};

// ─── Helpers (same as before) ─────────────────────────────────────────────────
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ─────────────────────────────────────────────────────────────────────────────
const Gazzaz_11 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
  const saveTimeoutRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const hasFetchedRef = useRef(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [parkingData, setParkingData] = useState(null);
  const [membershipData, setMembershipData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  
  const { enqueue } = useApiQueue();
  
  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? parkingData?.data?.car_park_bays?.value ?? '287';
  
  // Refs for parking inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const operationalHoursRef = useRef(null);
  const vatNoteRef = useRef(null);
  
  // Refs for membership table
  const membershipRefs = useRef([]);
  
  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const parkingDataRef = useRef(null);
  const membershipDataRef = useRef(null);
  const assetsDataRef = useRef(null);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "0020011",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        
        const parking = find('gazzaz_offstreet_parking_profile', FALLBACK_PARKING);
        const membership = find('gazzaz_membership_tariff', FALLBACK_MEMBERSHIP);
        const assets = find('gazzaz_assets_deployed', FALLBACK_ASSETS);
        
        setParkingData(parking);
        setMembershipData(membership);
        setAssetsData(assets);
        
        parkingDataRef.current = parking;
        membershipDataRef.current = membership;
        assetsDataRef.current = assets;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;
      
      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });
      
      groups.push(currentGroup);
    });
    
    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      
      // 🔥 totalBays - ab read-only value use karo
      const currentTotalBays = effectiveTotalBays;
      const currentContractTerm = contractTermRef.current?.value || parkingDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || parkingDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || parkingDataRef.current?.data?.contract_period?.end_date || '';
      const currentOperationalHours = operationalHoursRef.current?.value || parkingDataRef.current?.data?.operational_hours?.value || '';
      const currentVatNote = vatNoteRef.current?.value || parkingDataRef.current?.data?.vat_note?.value || '';
      
      // Build membership rows from refs
      const currentMembershipRows = (membershipDataRef.current?.data?.rows || []).map((row, rowIdx) => 
        row.map((_, colIdx) => membershipRefs.current[rowIdx]?.[colIdx]?.value || row[colIdx] || '')
      );
      
      const response = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1,
        tables: [
          { 
            table_key: parkingDataRef.current?.table_key || 'gazzaz_offstreet_parking_profile', 
            title: parkingDataRef.current?.title || 'Gazzaz Off Street Parking - Profile', 
            data: {
              car_park_bays: { label: 'Total Off-Street Parking Bays', value: currentTotalBays },
              contract_term: { label: 'Contract Term', value: currentContractTerm },
              contract_period: { start_date: currentStartDate, end_date: currentEndDate },
              operational_hours: { label: 'Operational Hours', value: currentOperationalHours },
              vat_note: { label: 'Rate per Hour', value: currentVatNote }
            }
          },
          { 
            table_key: membershipDataRef.current?.table_key || 'gazzaz_membership_tariff', 
            title: membershipDataRef.current?.title || 'Membership Tariff', 
            data: {
              columns: membershipDataRef.current?.data?.columns || ['MEMBERSHIP TARIFF', 'Price'],
              rows: currentMembershipRows
            }
          },
          { 
            table_key: assetsDataRef.current?.table_key || 'gazzaz_assets_deployed', 
            title: assetsDataRef.current?.title || 'Gazzaz Off-Street', 
            data: { groups: transformAssetsToApiFormat() }
          },
        ],
      });
      
      if (!response?.success) throw new Error(response?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!parkingData || !membershipData || !assetsData) {
    return <LoadingComponent/>;
  }

  const pkd = parkingData.data;
  const memColumns = membershipData.data.columns || [];
  const memRows = membershipData.data.rows || [];
  const flatAssets = groupsToFlat(assetsData.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">
      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{parkingData.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ── Left ── */}
        <div className="flex-1 !border-black pr-4">
          <div className="text-[13px] font-semibold mb-4">Activities:</div>

          {/* Car Park image box */}
          <div className="rounded mb-4 w-[140px] flex flex-col items-center">
            <img src={carpark1} alt="Car Park" className="w-48 h-48 object-contain" />
          </div>

          {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
          <div className="flex items-center gap-2 mb-1 ml-4">
            <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              {pkd.car_park_bays?.label}{' '}
              <strong>
                <input 
                  type="text" 
                  value={effectiveTotalBays}
                  readOnly 
                  disabled
                  className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
                />
              </strong>
            </span>
          </div>

          {/* Contract Term - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] flex items-center flex-wrap gap-1">
              Contract term{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pkd.contract_term?.value || ''}
                  ref={contractTermRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-13" 
                />
              </strong>
              ; start date{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pkd.contract_period?.start_date || ''}
                  ref={contractStartDateRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-18" 
                />
              </strong>
              {' to '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pkd.contract_period?.end_date || ''}
                  ref={contractEndDateRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-24" 
                />
              </strong>
            </span>
          </div>

          {/* Operational Hours - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Operational Hours –{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pkd.operational_hours?.value || ''}
                  ref={operationalHoursRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-48" 
                />
              </strong>
            </span>
          </div>

          {/* Rate per Hour - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Rate per Hour{' '}
              <strong>
                <input 
                  type="text" 
                  defaultValue={pkd.vat_note?.value || ''}
                  ref={vatNoteRef}
                  onChange={autoSave}
                  className="font-bold outline-none bg-transparent !border-0 border-b border-gray-300 focus:border-blue-500 text-[12px] w-48" 
                />
              </strong>
            </span>
          </div>

          {/* Assets Deployed */}
          <div className="flex items-center gap-2 ml-4 mb-6">
            <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-[12px]">Assets Deployed</span>
          </div>

          {/* Membership Rates Table - Editable */}
          <div className="ml-4">
            <table className="!border-collapse text-[11px]">
              <thead>
                <tr>
                  <th colSpan={memColumns.length} className="!border !border-black px-3 py-1.5 font-bold text-center bg-white">
                    {membershipData.title}
                  </th>
                </tr>
                <tr>
                  {memColumns.map((col, i) => (
                    <th key={i} className="!border !border-black px-3 py-1 font-semibold text-left bg-white"
                      style={{ minWidth: i === 0 ? '140px' : '110px' }}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {memRows.map((row, rIdx) => (
                  <tr key={rIdx}>
                    {row.map((cell, cIdx) => {
                      if (!membershipRefs.current[rIdx]) membershipRefs.current[rIdx] = [];
                      return (
                        <td key={cIdx} className="!border !border-black px-3 py-1">
                          <input 
                            type="text" 
                            defaultValue={cell}
                            ref={(el) => (membershipRefs.current[rIdx][cIdx] = el)}
                            onChange={autoSave}
                            className="outline-none bg-transparent !border-0 w-full text-[11px]" 
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Right — Assets ── */}
        <AssetsPanel
          assetsTable={assetsData}
          flatAssets={flatAssets}
          subCountRefs={assetSubCountRefs}
          totalCountRefs={assetTotalCountRefs}
          onSubCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], subCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
          onTotalCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
        />
      </div>
    </div>
  );
};

export default Gazzaz_11;